import React from "react";
import {Col, Row, FormGroup, Container} from "react-bootstrap";
import { Form, Input, Radio, Checkbox, DatePicker, Select } from 'antd';
import { Breadcrumb, ImageElement, LoginHeader} from "../../components";
import { Link } from "react-router-dom";

function MembershipPayment() {

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'Payment',
        },
    ];

    return(
        <>            
            <LoginHeader/>         
            <div className="main-content paymentPage">
                {/* page content */}
                <div className="pageContent">
                    <div className="pageContent_wide">
                        <Container className="container-lg">
                            <Breadcrumb title="Payment" breadcrumb={breadcrumb}/>
                            {/* Payment page content */}
                            <div className="br-10 p-30 bg-white">
                                <div className="paymentPage_head">
                                    <div>
                                        <h2 className="text-850 font-sm paymentPage_head_title mb-0">Add card</h2>
                                        <span>Please enter your card detail</span>
                                    </div>
                                </div>
                               <div className="paymentPage_card form-group">
                                    <div className="d-flex">
                                        <Form className="w-100">
                                            <div className="paymentPage_card_form mt-0" >
                                                <Row>
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label ">Card Holder Name</label>
                                                            <Input type="text" size="large" placeholder="Card Holder Name"value='Nikola Laringo' />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">Card Number</label>
                                                            <div className="position-relative">
                                                                <Input type="text" size="large" className="cardnumber" placeholder="Card Number" value='5654 - 4848 - 4848 - 0210'/>
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">Exp. Month</label>
                                                            <Select size="large" className="w-100" placeholder="Month" value="01"
                                                                options={[
                                                                    {
                                                                        value: '01',
                                                                        label: '01',
                                                                    },
                                                                    {
                                                                        value: '02',
                                                                        label: '02',
                                                                    },
                                                                    {
                                                                        value: '03',
                                                                        label: '03',
                                                                    },
                                                                    {
                                                                        value: '04',
                                                                        label: '04',
                                                                    },
                                                                    {
                                                                        value: '05',
                                                                        label: '05',
                                                                    },
                                                                    {
                                                                        value: '06',
                                                                        label: '06',
                                                                    },
                                                                    {
                                                                        value: '07',
                                                                        label: '07',
                                                                    },
                                                                    {
                                                                        value: '08',
                                                                        label: '08',
                                                                    },
                                                                    {
                                                                        value: '09',
                                                                        label: '09',
                                                                    },
                                                                    {
                                                                        value: '10',
                                                                        label: '10',
                                                                    },
                                                                    {
                                                                        value: '11',
                                                                        label: '11',
                                                                    },
                                                                    {
                                                                        value: '12',
                                                                        label: '12',
                                                                    },
                                                                ]}
                                                            />
                                                        </FormGroup>
                                                    </Col> 
                                                    <Col sm={6}>
                                                        <FormGroup className="form-group">
                                                            <label className="ant-label">Exp. Year</label>
                                                            <Select size="large" className="w-100" placeholder="Year" value="2023"
                                                                options={[
                                                                    {
                                                                        value: '2023',
                                                                        label: '2023',
                                                                    },
                                                                    {
                                                                        value: '2024',
                                                                        label: '2024',
                                                                    },
                                                                    {
                                                                        value: '2024',
                                                                        label: '2024',
                                                                    },
                                                                    {
                                                                        value: '2025',
                                                                        label: '2025',
                                                                    },
                                                                    {
                                                                        value: '2026',
                                                                        label: '2026',
                                                                    },
                                                                    {
                                                                        value: '2027',
                                                                        label: '2027',
                                                                    },
                                                                ]}
                                                            />
                                                        </FormGroup>
                                                    </Col> 
                                                    <Col sm={12}>
                                                        <FormGroup className="form-group mb-0">
                                                            <label className="ant-label">CVV</label>
                                                            <Input type="text" size="large" placeholder="CVV" />
                                                        </FormGroup>
                                                    </Col>  
                                                </Row>
                                            </div>
                                        </Form>
                                    </div>
                                </div>                                
                                <div className="d-flex justify-content-end">
                                    <Link to="/profile" className="font-sm btn btn-primary min-200 btn-lg">Save</Link>
                                </div>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MembershipPayment;